import React, { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams, useNavigate } from 'react-router-dom';
import LoginPage from './Pages/LoginPage/LoginPage';
import DashBoardPage from './Pages/DashBoardPage/DashBoardPage';
import './App.css';
import LeaderBoardDataProvider from './Contexts/LeaderBoardDataContext';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AccessProvider from './Contexts/AccessContext';
import ProtectedContributorPage from './Pages/ContributePage/ProtectedContributorPage';
import { ApiAccessProvider } from './Contexts/ApiAccessProvider';
import ProtectedContributorApiPage from './Pages/APIRepoContributePage/ProtectedContributorApiPage';
import APIRepoContributePage from './Pages/APIRepoContributePage/APIRepoContributePage';


const ValidDashboardPage = () => {
  const { activeUrl: paramUrl } = useParams();
  const navigate = useNavigate();

  const validUrls = useMemo(() => ['ui_repo', 'api_repo', 'help'], []);

  useEffect(() => {
    if (!validUrls.includes(paramUrl)) {
      navigate('/', { replace: true });
    }
  }, [paramUrl, navigate, validUrls]);

  return validUrls.includes(paramUrl) ? <AccessProvider><DashBoardPage /></AccessProvider> : null;
};

const AppProviders = ({ children }) => (

  <LeaderBoardDataProvider>
    <AccessProvider>
      <ApiAccessProvider>
        {children}
      </ApiAccessProvider>
    </AccessProvider>
  </LeaderBoardDataProvider>

);

const App = () => {
  const renderDashboardPage = () => (
    <>
      <AuthenticatedTemplate>
        <ValidDashboardPage />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/" />
      </UnauthenticatedTemplate>
    </>
  );

  return (
    <AppProviders>
      <div>
        <ToastContainer position="top-right" autoClose={3000} />
        <Router>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<Navigate to="/dashboard/ui_repo" />} />
            <Route path="/dashboard/:activeUrl" element={renderDashboardPage()} />
            <Route
              path="/UIRepo/Contributor"
              element={
                <AuthenticatedTemplate>
                  <AccessProvider><ProtectedContributorPage active={"UI Repo"} /></AccessProvider>
                </AuthenticatedTemplate>
              }
            />
            <Route path="/APIRepo/contributor" element={
              <AuthenticatedTemplate>
                <ApiAccessProvider>
                  <ProtectedContributorApiPage active={"API Repo"} />
                </ApiAccessProvider>
              </AuthenticatedTemplate>} />
            <Route path="/cont" element={
              <APIRepoContributePage active={"API Repo"} />}
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>

        </Router>
      </div>
    </AppProviders>
  );
};

export default App;
